export default {
  owner: 'owner',
  admin: 'admin',
  editor: 'editor',
  reader: 'reader',
  user: 'user'
}
